export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/menu_active-db2addcc858fe6d4d3ef4ce146bf2ea3.svg";